import { render } from "./PromocionesTruncas.vue?vue&type=template&id=67ce1070"
import script from "./PromocionesTruncas.vue?vue&type=script&lang=js"
export * from "./PromocionesTruncas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__